import Image from 'next/image'

import { useContactInfo } from '@/api/models/common/hooks/useContactInfo'
import { useRequestTypes } from '@/api/models/requests/hooks/useRequestTypes'
import { RequestTypeAlias } from '@/api/models/requests/lib/requests.types'
import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { cn } from '@/app/utils'
import { AppButton } from '@/components/shared/button'
import { useRequestNavigation } from '@/components/widgets/request/hooks/useRequestNavigation'

type Props = {
  isPermanent?: boolean
}

export const PassParkingPlug = ({ isPermanent }: Props) => {
  const { navigateToCreateFormPass } = useRequestNavigation()
  const { data: contactInfo } = useContactInfo()
  const hasContactPhone = Boolean(contactInfo?.contactPhone)
  const { breakpoint } = useCurrentBreakpoint()

  const { data: requestTypes } = useRequestTypes()
  const isMobileScreen = [ScreenSize.Xxs, ScreenSize.Xs].includes(breakpoint)

  const propertiesPassType = requestTypes?.find(
    requestType => requestType.alias === RequestTypeAlias.PropertiesPass
  )

  const handleRedirectToCreatePass = () => {
    navigateToCreateFormPass(RequestTypeAlias.PropertiesPass)
  }

  return (
    <div className="mb-20 flex h-full w-full flex-col items-center justify-between text-center">
      <div className="mx-60 mt-[200px] flex flex-col items-center justify-center gap-24 xxs:mx-0 xxs:mt-[105px] xxs:gap-20">
        <Image
          src="/images/passes/Parking.png"
          width={isMobileScreen ? 100 : 120}
          height={isMobileScreen ? 100 : 120}
          alt="parking-image"
        />
        {isPermanent ? (
          <strong className="max-w-[500px] text-24 xxs:text-18">
            Пропуск для личного транспорта оформляется только при наличии
            машино-места.
          </strong>
        ) : (
          <>
            <strong className="max-w-[500px] text-24 xxs:text-18">
              Пропуск для транспорта оформляется только при наличии машино-места
              или бесплатного гостевого паркинга.
            </strong>
            <p className="max-w-[400px] text-grey-60 text-20 lg:text-20 xxs:text-16">
              Для погрузки и разгрузки вы можете оформить разовый пропуск.
            </p>
          </>
        )}
      </div>
      <div
        className={cn(
          'flex w-full justify-center gap-10 xxs:flex-col',
          isPermanent && 'w-full'
        )}
      >
        {hasContactPhone && (
          <a
            href={`tel:${contactInfo?.contactPhone}`}
            className={cn(
              'font-bold text-grey-30 transition-colors text-24 hover:text-grey-50 md:w-full xxs:order-2',
              isPermanent && 'w-full'
            )}
          >
            <AppButton
              className={isPermanent ? 'w-full' : 'w-[350px] md:!w-full'}
              variant={isPermanent ? 'secondary' : 'backless'}
              size="large"
            >
              Звонок в Службу комфорта Sminex
            </AppButton>
          </a>
        )}

        {!isPermanent && propertiesPassType && (
          <AppButton
            className="w-[350px] md:!w-full xxs:order-1"
            variant="secondary"
            size="large"
            onClick={handleRedirectToCreatePass}
          >
            Создать пропуск на погрузку-загрузку
          </AppButton>
        )}
      </div>
    </div>
  )
}
